import { FlexSdkError } from "../error";
import { SimpleObservableImpl } from "~/modules/reporter/CustomObservable/SimpleObservable";
import { SimpleSubject } from "~/modules/reporter/CustomObservable/SimpleSubject";

export default class ErrorReporter extends Object {
    readonly #telemetryErrorSubject: SimpleSubject<FlexSdkError>;

    constructor() {
        super();
        this.#telemetryErrorSubject = new SimpleSubject<FlexSdkError>();
    }

    public get telemetryErrorStream(): SimpleObservableImpl<FlexSdkError> {
        return this.#telemetryErrorSubject.asObservable();
    }

    publishTelemetryError(e: FlexSdkError): void {
        this.#telemetryErrorSubject.next(e);
    }
}
